import {
    fileTypeIsAudio,
    fileTypeIsImage,
    fileTypeIsVideo,
} from './MessageAttachment';
import AudioPlayer from 'flow/components/tickets/convenience/AudioPlayer';
import Icon from 'flow/components/ui-components/Icon';

const HEIGHT = 200;

interface Props {
    aspectRatio?: number;
    fileType: string;
    fileName?: string;
}

const AttachmentBeingSentPlaceholder = ({
    aspectRatio,
    fileType,
    fileName,
}: Props) => {
    const width = !Number.isNaN(aspectRatio)
        ? Math.round(HEIGHT * aspectRatio)
        : undefined;

    if (fileTypeIsAudio(fileType)) {
        return (
            <div className="pointer-events-none flex w-full">
                <AudioPlayer url={null} presentDownload={true} />
            </div>
        );
    }

    if (fileTypeIsImage(fileType)) {
        return (
            <div
                className="animate-fade h-[200px] rounded-sm bg-gray-200"
                style={{
                    width: width ? `${width}px` : '200px',
                    maxWidth: '400px',
                }}
            />
        );
    }

    if (fileTypeIsVideo(fileType)) {
        return (
            <div className="pointer-events-none flex">
                <video
                    src={null}
                    className="animate-fade h-[200px] w-fit rounded-sm"
                    style={{
                        width: width ? `${width}px` : '200px',
                        maxWidth: '400px',
                    }}
                    controls={true}
                    preload="metadata"
                />
            </div>
        );
    }

    return (
        <div className="flex w-auto max-w-full min-w-[200px] items-center gap-x-2 rounded-sm border border-gray-300 p-2">
            <Icon iconKey="file" className="text-gray-600" />
            <span className="text-sm text-gray-800">{fileName}</span>
        </div>
    );
};

export default AttachmentBeingSentPlaceholder;
